export default function csrfToken(): string {
  return $('meta[name=csrf-token]').attr('content');
}
